import React from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import PropertySearch from './PropertySearch/PropertySearch'
import PageNotFound from './Common/PageNotFound/PageNotFound'
import HomePage from './HomePage/HomePage'
import EmailListsSearch from './EmailLists/Search/EmailListsSearch'
import EmailListsDashboard from './EmailLists/Dashboard/EmailListsDashboard'
import TitleComponent from './HomePage/TitleComponent'
import { ReactKeycloakProvider } from '@react-keycloak/web'
import keycloak from './keycloak'
import LoadingSpinner from '../Components/Common/LoadingSpinner/LoadingSpinner'
import BulkUploadResultPage from './EmailLists/Dashboard/BulkUploadResultPage'

const eventLogger = (event, error) => {
  let d = new Date();
  let currTime = `${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`
  console.log('onKeycloakEvent', currTime, event, error)
}
const initOptions = { onLoad: 'login-required', checkLoginIframe: false }

const App = () => {

  return (
    <>
      <ReactKeycloakProvider LoadingComponent={<LoadingSpinner></LoadingSpinner>}
        authClient={keycloak} onEvent={eventLogger} initOptions={initOptions}>
        <BrowserRouter>
          <TitleComponent />
          <Switch>
            <Route exact path="/" component={PropertySearch} />
            <Route path="/PropertySearch" component={PropertySearch} />
            <Route path="/PropertyList" component={PropertySearch} />
            <Route path="/404PageNotFound" component={PageNotFound} />
            <Route path='*' exact={true} component={PageNotFound} >
              <Redirect from='*' to='/404PageNotFound' />
            </Route>
            {/* <Route path="/bkpuploadcsv" component={BulkUploadResultPage} /> */}
            {/* <Route path="/EmailListInitialPage" component={EmailListsDashboard} /> */}
            {/* <Route path="/EmailLists" component={EmailListsSearch} /> */}
            {/* <Route path="/EmailListDetails" component={EmailListsSearchNew} /> */}
            {/* <Route path='/BulkUpload' component={() => {
              window.location.href = '/api/emaillist/uploadfile';
              return null;
            }} /> */}
          </Switch>
        </BrowserRouter>
      </ReactKeycloakProvider>
    </>
  )
}

export default App
